import ResponsiveComponent from '@/components/common/ResponsiveComponent';
import { ResultStatsProps } from '@/types/other';
import translationFallback from '@/utilites/translations/translationFallback';
import { useTranslation } from 'next-i18next';
import { useInstantSearch } from 'react-instantsearch';

export default function ResultStats() {
  const { results } = useInstantSearch();
  const { t: tCommon } = useTranslation('common');

  return (
    <span>
      ({results.nbHits}{' '}
      {translationFallback('results', tCommon('results'), 'Results')})
    </span>
  );
}
